import React from 'react';
import { theme } from './theme';

const GlobalStyles: React.FC = () => {
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      
      html, body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
        background-color: ${theme.colors.background};
        color: ${theme.colors.text};
        line-height: 1.5;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      
      #root {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
      
      button {
        cursor: pointer;
        border: none;
        outline: none;
        font-family: inherit;
        transition: all ${theme.transitions.fast};
      }
      
      button:focus-visible {
        outline: 2px solid ${theme.colors.primary};
        outline-offset: 2px;
      }
      
      img {
        max-width: 100%;
        height: auto;
      }
      
      .album-cover {
        border-radius: ${theme.borderRadius.md};
        box-shadow: ${theme.shadows.md};
        transition: transform ${theme.transitions.normal}, box-shadow ${theme.transitions.normal};
      }
      
      .album-cover:hover {
        transform: translateY(-2px);
        box-shadow: ${theme.shadows.lg};
      }
      
      .filter-panel {
        background: ${theme.colors.surface};
        border-radius: ${theme.borderRadius.lg};
        border: 1px solid ${theme.colors.border};
      }
      
      .filter-chip {
        background: ${theme.colors.primary};
        color: white;
        border-radius: ${theme.borderRadius.md};
        padding: ${theme.spacing.xs} ${theme.spacing.sm};
        font-size: 0.875rem;
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing.xs};
      }
      
      .filter-chip button {
        background: none;
        color: inherit;
        padding: 0;
        margin-left: ${theme.spacing.xs};
      }
      
      .scrollbar-thin::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      
      .scrollbar-thin::-webkit-scrollbar-track {
        background: ${theme.colors.surface};
        border-radius: ${theme.borderRadius.sm};
      }
      
      .scrollbar-thin::-webkit-scrollbar-thumb {
        background: ${theme.colors.primary};
        border-radius: ${theme.borderRadius.sm};
      }
      
      .scrollbar-thin::-webkit-scrollbar-thumb:hover {
        background: ${theme.colors.primaryDark};
      }
      
      @media (max-width: ${theme.breakpoints.md}) {
        html {
          font-size: 14px;
        }
      }
    `;
    
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  
  return null;
};

export default GlobalStyles;